import { Link } from "react-router-dom";
import styled from "styled-components";
import { cPath } from "../../constants";
import { Container } from "../layout/Container";

const Bar = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-bottom: 1px solid hsl(${({ theme }) => theme.colors.border});
`;

const Inner = styled(Container)`
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

const A = styled(Link)`
  &:hover {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

const Strong = styled.span`
  color: hsl(${({ theme }) => theme.colors.foreground});
  font-weight: 500;
`;

export default function StoreBreadcrumbBar({ store, storeName }) {
  const name = store?.name || storeName || "Store";

  return (
    <Bar>
      <Inner>
        <A to={cPath("")}>Home</A>
        <span>/</span>
        <A to={cPath("stores")}>Stores</A>
        <span>/</span>
        <Strong>{name}</Strong>
      </Inner>
    </Bar>
  );
}
